export const searchWinLoseReportMock = {
	data: [
		{
			operatorName: 'a',
			timeZone: '4',
			totalBetCount: '123',
			totalActivePlayer: '123',
			winLoseList: [
				{
					currency: 'MYR',
					betCount: '123',
					validTurnover: '123',
					turnover: '123',
					playerWinLose: '123',
					operatorWinLose: '123',
					promotionPayout: '123',
					voucherPayout: '0',
					godziDropPayout: '0',
					totalPayout: '123',
					betWinLose: '123',
				},
				{
					currency: 'MYR',
					betCount: '123',
					validTurnover: '123',
					turnover: '123',
					playerWinLose: '123',
					operatorWinLose: '123',
					promotionPayout: '123',
					voucherPayout: '0',
					godziDropPayout: '0',
					totalPayout: '123',
					betWinLose: '123',
				},
			],
		},
		{
			operatorName: 'b',
			timeZone: '8',
			totalBetCount: '123',
			totalActivePlayer: '123',
			winLoseList: [
				{
					currency: 'MYR',
					betCount: '123',
					validTurnover: '123',
					turnover: '123',
					playerWinLose: '123',
					operatorWinLose: '123',
					totalPayout: '123',
					betWinLose: '123',
				},
				{
					currency: 'MYR',
					betCount: '123',
					validTurnover: '123',
					turnover: '123',
					playerWinLose: '123',
					operatorWinLose: '123',
					promotionPayout: '123',
					voucherPayout: '0',
					godziDropPayout: '0',
					totalPayout: '40666888',
					betWinLose: '123',
				},
			],
		},
	],
};

export default searchWinLoseReportMock;
